/**
 * useGymRole — the current user's standing in the active gym.
 *
 * The member document itself comes from `GymProvider`, which holds the one
 * listener on it (see that file for the four this replaced and how they
 * disagreed). What is left here is the reading: role, and the two derived
 * flags that predate the capability system.
 */
import { useMemo } from "react";
import { useGym } from "../contexts/GymContext";
import { useCurrentUser } from "../contexts/CurrentUserContext";

export function useGymRole() {
  const { ownMember } = useGym();
  const { userData } = useCurrentUser();

  // `undefined` (not loaded) and `null` (not a member) both read as no member
  // doc here; callers that need to tell them apart read `ownMember` directly.
  const memberData = ownMember || null;
  const role = memberData?.role || "user";
  const isPlatformAdmin = userData?.platformRole === "platformAdmin";

  return useMemo(() => ({
    role,
    memberData,
    loading: ownMember === undefined,
    isSetter: role === "setter" || role === "gymAdmin" || isPlatformAdmin,
    isGymAdmin: role === "gymAdmin" || isPlatformAdmin,
    isPlatformAdmin,
  }), [role, memberData, ownMember, isPlatformAdmin]);
}
